import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=f5240ccc&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&id=f5240ccc&prod&scoped=true&lang=scss&"
import style1 from "./Project.vue?vue&type=style&index=1&id=f5240ccc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5240ccc",
  null
  
)

export default component.exports